function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { j as e } from "./index.es33.js";
import { clsx as s } from "./index.es105.js";
import { Typography as y } from "./index.es35.js";
import { palette as N } from "./index.es36.js";
import { inputSelectors as b } from "./index.es107.js";
import { InputHint as W } from "./index.es108.js";
import { Icon as i } from "./index.es7.js";
import { InputPickerSize as I } from "./index.es59.js";
import r from "./index.es111.js";
import t from "./index.es466.js";
var H = function H(_ref) {
  var a = _ref.label,
    o = _ref.isDisabled,
    p = _ref.isError,
    n = _ref.children,
    c = _ref.isFocused,
    l = _ref.onFocus,
    m = _ref.onBlur,
    d = _ref.size,
    u = _ref.inputValue,
    x = _ref.onClear,
    f = _ref.hint,
    j = _ref.postfix,
    h = _ref.isClearable;
  return e.jsx("div", {
    className: t.inputWrapper,
    children: e.jsxs("label", {
      className: s(r.container, _defineProperty(_defineProperty({}, r.containerWithError, p), r.containerDisabled, o)),
      children: [a && e.jsx(y.Body2, {
        as: "div",
        className: s(r.labelContainer, r.label),
        children: a
      }), e.jsxs("div", {
        className: s(r.wrapper, t.inputInner, b.classNames.wrapper, _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, r.largeSizeWrapper, d === I.large), r.wrapperFocused, c && !p), r.wrapperWithError, p), r.wrapperDisabledStyles, o)),
        onFocus: l,
        onBlur: m,
        children: [n, e.jsx("div", {
          className: s(t.inputIconWrapper, _defineProperty({}, t.inputIconWrapperDisabled, o)),
          children: u && h ? e.jsx("button", {
            className: t.button,
            disabled: o,
            type: "button",
            onClick: x,
            children: e.jsx(i, {
              className: t.iconClear,
              color: N.gray6,
              size: 16,
              icon: i.icons.system.s.utilities.cross
            })
          }) : j
        })]
      }), e.jsx(W, {
        isError: p,
        hint: f
      })]
    })
  });
};
export { H as PickerWrapper };